import Vue from 'vue'
import axios from 'axios'
import baseUrl from './base-url'

const VALID_EXTENSION = ['png', 'jpg', 'jpeg']

export default function({ state, rootState }, { file }) {
    let extension = file.name.substring(file.name.lastIndexOf('.') + 1)

    if (! VALID_EXTENSION.includes(extension)) {
        Vue.set(state.upload, file.name, {
            error: { code: 'InvalidFileType' }
        })
        return Promise.reject({ code: 'InvalidFileType' })
    }

	return axios.get(baseUrl + '/user/' + rootState.auth.id + '/upload?type=' + extension, {
        withCredentials: true
    })
	.then((response) => {
        console.log(response)
		let formData = getForm(response.data, file, extension)
        Vue.set(state.upload, file.name, { progress: 0.0 })

		return axios.post(response.data.url, formData, {
			headers: {
				'Content-Type': extension
			},
            withCredentials: false,
			onUploadProgress: function(progress) {
                Vue.set(state.upload, file.name, { progress: (progress.loaded * 100.0) / progress.total })
            }
		})
		.then((res) => {
            console.log(res)
			Vue.set(state.upload, file.name, 100.0)
			return {
				url: response.public
			}
		})
        .catch((error) => {
            console.log(error)
            Vue.set(state.upload, file.name, { error })
            throw error
        })
	})
}

function getForm(response, file, extension) {
	var formData = new FormData()
	formData.append('key', response.key)
	formData.append('Policy', response.policy)
	formData.append('X-Amz-Signature', response.signature)
	formData.append('X-Amz-Credential', response.credential)
	formData.append('X-Amz-Algorithm', response.algorithm)
	formData.append('X-Amz-Date', response.date)
	formData.append('acl', response.acl)
	formData.append('X-Amz-Security-Token', response.security)
	formData.append('Content-Type', extension)
	formData.append('file', file)
	return formData
}
